<template>
  <div id="verified">


    <div class="card-other">
      <h4>
        尊敬的用户,为了贯彻工信部《电话用户真实身份信息登记规定》,请对您购买的流量卡进行实名认证。
      </h4>
      <div class="main">
        <p>温馨提示： </p>
        <br>
        <p>1，所有卡必须完成实名后方能正常使用 </p>
        <br>
        <p>2，实名前请准备身份证等实名信息</p>
        <br>
        <p style="color:red">3，实名卡号：{{ verifiedInfo.iccid }}</p>
        <div class="btnOuter" style="background: #26a2ff">
          <mt-button style="background: #26a2ff" class="tag-read" data-clipboard-action="copy"
            :data-clipboard-text="verifiedInfo.iccid" type="primary" size="large"
            @click.prevent="sureVerifiedHandler">点击复制卡号，去完成实名</mt-button>
        </div>

      </div>
    </div>
    <!-- 图片实名认证 -->
    <van-dialog v-model="showimg" title="请扫描下方二维码实名" show-cancel-button>
      <img style="width:100%;" src="@/assets/suolangunicom.jpg" />
    </van-dialog>
  </div>
</template>
<script>
import Clipboard from 'clipboard';
import { wxRequest, verified } from "@/api/user";
import { Dialog } from "vant";
export default {
  data() {
    return {
      qianhairealname: false,
      state: "",
      supplierTypeCode: "",
      verifiedInfo: {
        iccid: localStorage.getItem('iccid'),
        name: "张三",
        userPhone: "",
        idcard: "41152819960319589X",
        code: null
      },
      disabledFlag: false,
      existFrontImg: false,
      existBackImg: false,
      existHandImg: false,
      frontImgUrl: "",
      backImgUrl: "",
      handImgUrl: "",
      realNameCard: -1, //需弹实名的卡
      isFirst: 0,
      showimg: false
    };
  },
  methods: {
    sureVerifiedHandler() {
      if (this.$route.query.iccid && this.$route.query.iccid.length > 2) {
        this.verifiedInfo.iccid = this.$route.query.iccid;
      }
      console.log('卡号' + this.verifiedInfo.iccid);
      var clipboard = new Clipboard('.tag-read')
      clipboard.on('success', e => {
        console.log('复制成功')
        clipboard.destroy()// 释放内存
        window.location.href = 'https://m.10099.com.cn/h5wap/busiClient/activateIOTCard/authenticationIccId.html';
      })
    },

  },
  created() {
    if (this.$route.query.iccid && this.$route.query.iccid.length > 2) {
      this.verifiedInfo.iccid = this.$route.query.iccid;
    }
  },

  mounted() {

  },
};
</script>
<style lang="less">
#verified {
  height: 100%;

  h4 {
    color: #fff;
    font-size: 10px;
    background: #26a2ff;
    line-height: 1.5em;
    padding: 6px 3%;
  }

  ul {
    margin: 10px;

    li {
      line-height: 36px;
      padding: 3px 0;
      border-bottom: 1px solid #ffa33a;

      svg {
        vertical-align: middle;
        margin-right: 8px;
      }

      .codeBtn {
        float: right;
        margin-top: 2px;
      }
    }
  }

  .main {
    height: calc(100% - 48px);
    padding: 0 4%;

    form {
      height: 100%;
    }

    .line {
      border-bottom: 1px solid #e5e5e5;
    }

    // .many {
    //     display: flex;
    //     justify-content: space-between;
    //     label {
    //         display: block;
    //         line-height: 36px;
    //     }
    //     .uploadOuter {
    //         position: relative;
    //         display: flex;
    //         justify-content: center;
    //         align-items: center;
    //         width: 48%;
    //         height: 100px;
    //         border: 1px dashed #e5e5e5;
    //         box-sizing: border-box;
    //         input[type=file] {
    //             position: absolute;
    //             top: 0;
    //             width: 0;
    //             width: 100%;
    //             height: 100%;
    //             opacity: 0;
    //         }
    //         img {
    //             width: 100%;
    //             height: 100%;
    //         }
    //     }
    // }
    // .title {
    //     line-height: 28px;
    //     margin-top: 10px;
    // }
    .btnOuter {
      // display: flex;
      // align-items: center;
      // height: calc(100% - 424px;)
      background: #26a2ff;

      margin-top: 30px;
    }
  }

  .card-dianxin {
    width: 100%;
    height: 100%;

    h1 {
      font-size: 14px;
      background: #fff;
      line-height: 1.5em;
      padding: 6px 3%;
    }

    .dianxin-iframe {
      width: 100%;
      height: 100%;
    }
  }

  .card-other {
    width: 100%;
    height: 100%;
  }

  input.van-field__control {
    padding-left: 5px;
    line-height: 24px;
  }
}</style>
